document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll("[data-video]");

  buttons.forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const videoUrl = this.getAttribute("data-video");

      const popup = document.createElement("div");
      popup.style.position = "fixed";
      popup.style.top = "0";
      popup.style.left = "0";
      popup.style.width = "100%";
      popup.style.height = "100%";
      popup.style.background = "rgba(0,0,0,0.8)";
      popup.style.display = "flex";
      popup.style.alignItems = "center";
      popup.style.justifyContent = "center";
      popup.style.zIndex = "9999";

      const video = document.createElement("video");
      video.src = videoUrl;
      video.controls = true;
      video.autoplay = true;
      
      video.style.width = "600px";
video.style.maxWidth = "90%";
video.style.height = "auto";
video.style.borderRadius = "12px";

      popup.appendChild(video);

      popup.addEventListener("click", () => {
        popup.remove();
      });

      document.body.appendChild(popup);
    });
  });
});